import { WebConfig } from '@ytl/common-model';
const config: WebConfig = { ...(window as unknown as { cfg: WebConfig }).cfg };
export const getConfig = () => {
  return config;
};
